"use client";

import React, { useEffect, useRef } from "react";
import extractVideoId from "./../helpers/videoHelper";
import Player from "@vimeo/player";

const VimeoPlayer = ({ videoUrl, width, height, size = "default" }) => {
  const url = extractVideoId(videoUrl);
  const playerRef = useRef(null);

  useEffect(() => {
    let player = new Player(url, {
      id: url,
      width: width ? width : "100%",
      height: height ? height : "auto",
    });

    // player.on('play', () => {
    //   console.log('Video played');
    // });

    playerRef.current = player;

    return () => {
      player.destroy();
    };
  }, [url]);

  return (
    <div
      id={url}
      ref={playerRef}
      className={`tps-video-frame-wrapper tps-video-${size} tps-float-medium tps-float-left`}
    ></div>
  );
};

export default VimeoPlayer;
